var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "pa-2",
      attrs: { "max-width": "500px", "min-width": "300px" },
    },
    [
      !!_vm.isShowBtnSubmit
        ? _c(
            "v-card-actions",
            { staticClass: "pb-2" },
            [
              !!_vm.tooltipMsg
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function ({ on, attrs }) {
                              return [
                                _c(
                                  "div",
                                  _vm._g(
                                    { staticStyle: { width: "100%" } },
                                    on
                                  ),
                                  [
                                    _c(
                                      "v-btn",
                                      _vm._b(
                                        {
                                          attrs: {
                                            block: "",
                                            color: "success darken-2",
                                            type: "submit",
                                            disabled:
                                              _vm.isLoading ||
                                              _vm.isSubmitDisabled,
                                            isLoading: _vm.isLoading,
                                          },
                                          on: { click: _vm.submit },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.isNew
                                                ? "создать"
                                                : "сохранить"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2993692868
                      ),
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.tooltipMsg))])]
                  )
                : _c(
                    "v-btn",
                    {
                      attrs: {
                        block: "",
                        color: "success darken-2",
                        type: "submit",
                        disabled: _vm.isLoading || _vm.isSubmitDisabled,
                        isLoading: _vm.isLoading,
                      },
                      on: { click: _vm.submit },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.isNew ? "создать" : "сохранить") + " "
                      ),
                    ]
                  ),
            ],
            1
          )
        : _vm._e(),
      _c("v-divider"),
      _c(
        "v-card-text",
        {
          staticClass: "_app-scrollbar pa-0",
          staticStyle: { "overflow-y": "auto", "max-height": "70vh" },
        },
        [
          _c(
            "v-card",
            { attrs: { flat: "" } },
            [
              _vm.createdAt || _vm.updatedAt || _vm.publishedAt
                ? _c("v-card-subtitle", { staticClass: "grey--text" }, [
                    _vm._v(" Основная информация "),
                  ])
                : _vm._e(),
              _c(
                "v-card-text",
                [
                  _vm._t("info-prepend"),
                  _vm.createdAt
                    ? _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "6" } }, [
                            _vm._v(" Создано: "),
                          ]),
                          _c("v-col", { attrs: { cols: "6" } }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm
                                    .moment(_vm.createdAt)
                                    .format(_vm.$options.defaultDateTimeFormat)
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.updatedAt
                    ? _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "6" } }, [
                            _vm._v(" Обновлено: "),
                          ]),
                          _c("v-col", { attrs: { cols: "6" } }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm
                                    .moment(_vm.updatedAt)
                                    .format(_vm.$options.defaultDateTimeFormat)
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.entityId && _vm.entityType
                    ? _c(
                        "v-row",
                        { attrs: { align: "center" } },
                        [
                          _c("v-col", { attrs: { cols: "6" } }, [
                            _vm._v(" Действия "),
                          ]),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "page-actions-dictionary",
                                      query: {
                                        t_id: +_vm.entityId,
                                        t_scope: _vm.entityType,
                                      },
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    { attrs: { icon: "" } },
                                    [_c("v-icon", [_vm._v("mdi-history")])],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.publishedAt
                    ? _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "6" } }, [
                            _vm._v(" Опубликовано: "),
                          ]),
                          _c("v-col", { attrs: { cols: "6" } }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm
                                    .moment(_vm.publishedAt)
                                    .format(_vm.$options.defaultDateTimeFormat)
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.author
                    ? _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "6" } }, [
                            _vm._v(" Автор: "),
                          ]),
                          _c("v-col", { attrs: { cols: "6" } }, [
                            _vm._v(" " + _vm._s(_vm.author) + " "),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._t("info-append"),
                ],
                2
              ),
            ],
            1
          ),
          _vm.isLocales
            ? [
                _c("v-divider"),
                _c(
                  "v-card",
                  { attrs: { flat: "" } },
                  [
                    _c("v-card-subtitle", { staticClass: "grey--text" }, [
                      _vm._v(" Локализация "),
                    ]),
                    _c(
                      "v-card-text",
                      [
                        _c(
                          "v-row",
                          { attrs: { "no-gutters": "" } },
                          [
                            _c("v-select", {
                              attrs: {
                                outlined: "",
                                "item-value": "value",
                                "item-text": "title",
                                "hide-details": "",
                                dense: "",
                                items: _vm.$options.contentLocales,
                                disabled: _vm.isNew || _vm.isLoading,
                                loading: _vm.isLoading,
                                value: _vm.language,
                              },
                              on: { change: _vm.updateLocaleHandler },
                            }),
                          ],
                          1
                        ),
                        false
                          ? _c(
                              "v-row",
                              { attrs: { align: "center" } },
                              [
                                _c("v-col", { attrs: { cols: "6" } }, [
                                  _vm._v(" Доступно на портале "),
                                ]),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _vm.translations
                                      ? _c("v-switch", {
                                          attrs: {
                                            inset: "",
                                            dense: "",
                                            disabled: _vm.isLoading,
                                            loading: _vm.isLoading,
                                            "input-value":
                                              _vm.getTranslationStatus(),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit(
                                                "update-translations",
                                                {
                                                  [_vm.language]: {
                                                    isEnabled: $event,
                                                  },
                                                }
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("v-divider"),
              ]
            : _vm._e(),
          _vm.isShowSortOrder
            ? [
                _c("v-divider"),
                _c(
                  "v-card",
                  { attrs: { flat: "" } },
                  [
                    _c("v-card-subtitle", { staticClass: "grey--text" }, [
                      _vm._v(" Сортировка "),
                    ]),
                    _c(
                      "v-card-text",
                      [
                        _c(
                          "v-row",
                          { attrs: { "no-gutters": "" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                outlined: "",
                                dense: "",
                                loading: _vm.isLoading,
                                disabled: _vm.isLoading,
                                value: _vm.sortOrder,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit("update-sort-order", $event)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        false
                          ? _c(
                              "v-row",
                              { attrs: { align: "center" } },
                              [
                                _c("v-col", { attrs: { cols: "6" } }, [
                                  _vm._v(" Доступно на портале "),
                                ]),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _vm.translations
                                      ? _c("v-switch", {
                                          attrs: {
                                            inset: "",
                                            dense: "",
                                            disabled: _vm.isLoading,
                                            loading: _vm.isLoading,
                                            "input-value":
                                              _vm.getTranslationStatus(),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$emit(
                                                "update-translations",
                                                {
                                                  [_vm.language]: {
                                                    isEnabled: $event,
                                                  },
                                                }
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("v-divider"),
              ]
            : _vm._e(),
          _vm._t("body"),
          _c("v-divider", { staticClass: "my-5" }),
        ],
        2
      ),
      _c(
        "v-card-actions",
        { staticClass: "mt-auto" },
        [
          _c(
            "v-btn",
            {
              attrs: {
                width: "100%",
                type: "button",
                text: "",
                color: "grey darken-1",
                disabled: _vm.isLoading,
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("cancel")
                },
              },
            },
            [_vm._v(" отмена ")]
          ),
        ],
        1
      ),
      _c(
        "v-card-actions",
        { staticClass: "mt-auto" },
        [
          !_vm.isNew
            ? _c(
                "v-btn",
                {
                  attrs: {
                    block: "",
                    text: "",
                    color: "error darken-2",
                    disabled: _vm.isLoading || _vm.isProtected,
                    isLoading: _vm.isLoading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("delete")
                    },
                  },
                },
                [_vm._v(" удалить ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }